if (!Element.prototype.matches) {
    Element.prototype.matches =
        Element.prototype.msMatchesSelector ||
        Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
        var el = this;

        do {
            if (Element.prototype.matches.call(el, s)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}

(function () {
    function Gallery(gallery) {
        /**
         * local object availability
         * @type {Gallery}
         * @private
         */
        var _this = this;

        /**
         * Selector for the show more btn
         * @type {string}
         * @private
         */
        this.showMoreButtonSelector = '.td-gallery-ft-action-show-more';

        /**
         * Selector for the show less btn
         * @type {string}
         * @private
         */
        this.showLessButtonSelector = '.td-gallery-ft-action-show-less';

        /**
         * Selector for the gallery
         * @type {string}
         * @private
         */
        this.gallerySelector = '.td-gallery-tiles';

        /**
         * Selector for the gallery tiles
         * @type {string}
         * @private
         */
        this.galleryTilesSelector = '.td-gallery-tiles-tile';

        /**
         * Selector for the large image (if enabled)
         * @type {string}
         * @private
         */
        this.largeImageSelector = '.td-gallery-large-image img';

        /**
         * Selector whether the large image layout is enabled
         * @type {string}
         * @private
         */
        this.largeImageEnabledSelector = '.td-gallery-large-image-enabled';

        /**
         * Bind the event listener to the show more button and handle its click
         *
         * @method bindShowMoreBtnEvent
         * @returns {undefined}
         */
        this.bindShowMoreBtnEvent = function () {
            if (_this.inNeosBackend()) {
                return;
            }
            var button = gallery.querySelector(_this.showMoreButtonSelector);
            button.addEventListener('click', function () {
                var emittedGallery = this.closest(_this.gallerySelector);
                var emittedGalleryTiles = emittedGallery.querySelectorAll(_this.galleryTilesSelector);

                emittedGalleryTiles.forEach(
                    function (galleryTile) {
                        galleryTile.classList.remove('hide-on-mobile');
                    }
                )
                this.classList.add('hidden');
                emittedGallery.querySelector(_this.showLessButtonSelector).classList.remove('hidden');
            });
        };

        /**
         * Bind the event listener to the show less button and handle its click
         *
         * @method bindShowMoreBtnEvent
         * @returns {undefined}
         */
        this.bindShowLessBtnEvent = function () {
            if (_this.inNeosBackend()) {
                return;
            }
            var button = gallery.querySelector(_this.showLessButtonSelector);
            button.addEventListener('click', function () {
                var emittedGallery = this.closest(_this.gallerySelector);
                var emittedGalleryTiles = emittedGallery.querySelectorAll(_this.galleryTilesSelector);

                emittedGalleryTiles.forEach(
                    function (galleryTile) {
                        galleryTile.classList.add('hide-on-mobile');
                    }
                )
                this.classList.add('hidden');
                emittedGallery.querySelector(_this.showMoreButtonSelector).classList.remove('hidden');
            });
        };

        /**
         * Check if the large image layout is enabled
         *a
         * @method isLargeImageEnabled
         * @returns {boolean}
         */
        this.isLargeImageEnabled = function () {
            var enableLargeImages = gallery.querySelector(_this.largeImageEnabledSelector);
            if (enableLargeImages !== undefined && enableLargeImages !== null) {
                return enableLargeImages.length !== 0;
            }
            return false;
        }
        /**
         * Bind the click event on Tiles to swap the large image with the clicked one
         *
         * @method bindTileClickEvent
         * @returns {undefined}
         */
        this.bindTileClickEvent = function () {
            var tiles = gallery.querySelectorAll(_this.galleryTilesSelector);
            for (var i = 0; i < tiles.length; i++) {
                var tile = tiles[i];
                tile.addEventListener('click', function (e) {
                    var lightboxData = JSON.parse(this.dataset.imageLightbox);
                    var src = lightboxData.src
                    var largeImage = gallery.querySelector(_this.largeImageSelector);
                    largeImage.src = src;
                });
            }
        }

        /**
         * Check if in neos backend
         *
         * @method inNeosBackend
         * @returns {boolean}
         */
        this.inNeosBackend = function () {
            var body = document.querySelector('body');
            return body.classList.contains('neos-backend');
        }

        /**
         * Initializes all of the required components for the Gallery page
         *
         * @method init
         * @returns {undefined}
         */
        this.init = function () {

            if(_this.isLargeImageEnabled()){
                _this.bindTileClickEvent();
            }
            _this.bindShowMoreBtnEvent();
            _this.bindShowLessBtnEvent();
        };
        _this.init();
    }

    /**
     * global availability
     */
    window.TechDivision = window.TechDivision || {};
    window.TechDivision.Gallery = Gallery;
})();

/**
 * Initialize all of the events if dom has loaded
 */
if (document.readyState !== 'loading') {
    initGalleries();
} else {
    document.addEventListener('DOMContentLoaded', function () {
        initGalleries();
    });
}

/**
 * Global function to initialize all of the galleries on a page
 * Global function to initialize all of the galleries on a page
 * Gets called on document content loaded
 *
 * @method initGalleries
 * @returns {undefined}
 */
function initGalleries() {
    var galleries = document.querySelectorAll('.td-gallery-tiles');
    for (var i = 0; i < galleries.length; i++) {
        new window.TechDivision.Gallery(galleries[i]);
    }
}
